import { z } from 'zod'

export const profitSummaryResponseSchema = z.object({
  buyTotal: z.number(), // Σ BUY payments (signed, ≤ 0)
  sellTotal: z.number(), // Σ SELL payments (signed, ≥ 0)
  accruals: z.number(), // gross dividends + coupons (≥ 0)
  taxes: z.number(), // signed (≤ 0)
  commissions: z.number(), // signed (≤ 0)
  other: z.number(), // signed catch-all
  currency: z.string(),
})

export type ProfitSummaryResponseDto = z.infer<typeof profitSummaryResponseSchema>
